import React, { useState, useEffect } from 'react'
import Loading from '../Loading/Loading'
import {MemoisedGalleryThumbs} from './GalleryThumbs'
import GalleryActiveItem from './GalleryActiveItem'
import {GalleryItem} from "./models/GalleryItem";

interface GalleryProps {
    apiUrl: string;
    sectionTitle?: string;
    productName: string;
    regionCode: string;
}

const Gallery = (props:GalleryProps) => {

    const [GalleryItems, setGalleryItems] = useState([] as GalleryItem[])
    const [LoadingState, setLoading] = useState(true)
    const [ActiveImage, setActiveImage] = useState<GalleryItem>(undefined)

    const getData = () => {
        let data = {productName: props.productName, regionCode: props.regionCode}
        fetch(props.apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' },  body: JSON.stringify(data)})
            .then((res) => res.json())
            .then((res) => {
                console.log(res)
                
                let mappedResult = res.Items.map((item:any) => {
                    return {
                        itemType: item.ItemType,
                        thumbnailUrl: item.ThumbNail,
                        altText: item.AltText,
                        originalUrl: item.Original
                    } as GalleryItem
                })
                
                setGalleryItems(mappedResult)
                setActiveImage(mappedResult[0])
                setLoading(false)
            })
    }

    //Same as componentDidMount (note array on end)
    useEffect(() => {
        console.log("Getting gallery data")
        getData()
    }, [])

    const changeGalleryItem = (e) => {
        var galleryItemsIndex = GalleryItems.indexOf(e)
        setActiveImage(GalleryItems[galleryItemsIndex])
        console.log(galleryItemsIndex);
    }

    return LoadingState ? (
        <Loading loadingtext="" />
    ) : (GalleryItems.length > 0 &&
        <div className="gallery-viewer">

            {props.sectionTitle != undefined && props.sectionTitle != "" && 
                <div className="onepcssgrid-1300 onepcssblockgrid">
                    <div className="onerow">
                        <div className="col12 last">
                            <h2>{props.sectionTitle}</h2>
                        </div>
                    </div>
                </div>
            }
            
            <GalleryActiveItem activeImage={ActiveImage} />

            <MemoisedGalleryThumbs
                galleryItems={GalleryItems}
                onGalleryClick={changeGalleryItem}
                activeImage={ActiveImage}
                largeThumbFilename={ActiveImage.thumbnailUrl}
                description={ActiveImage.altText}
            />
        </div>
    )
}

export default Gallery